import { cva } from 'class-variance-authority';

const optionButton = cva(
  [
    'size-full overflow-hidden',
    'rounded-lg border border-solid',
    'flex items-center',
    'hover:border-white hover:bg-white',
  ],
  {
    variants: {
      checked: {
        true: 'border-gray-400 bg-white',
        false: 'border-gray-300 bg-gray-300',
      },
    },
  },
);

export default optionButton;
